var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgValueGroup = function SvgValueGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M40 52.9c7.125 0 12.9-5.775 12.9-12.9S47.125 27.1 40 27.1 27.1 32.875 27.1 40 32.875 52.9 40 52.9m0 2c8.23 0 14.9-6.67 14.9-14.9S48.23 25.1 40 25.1 25.1 31.77 25.1 40 31.77 54.9 40 54.9M40 16.573a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 2a5 5 0 1 0 0-10 5 5 0 0 0 0 10",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M39 24.084v-6h2v6zM40 63.427a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0-2a5 5 0 1 0 0 10 5 5 0 0 0 0-10",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M41 55.916v6h-2v-6zM23.435 23.435a3 3 0 1 0-4.243-4.243 3 3 0 0 0 4.243 4.243m1.414 1.414a5 5 0 1 0-7.071-7.071 5 5 0 0 0 7.071 7.071",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m28.039 29.453-4.243-4.243 1.414-1.414 4.243 4.243zM56.565 56.565a3 3 0 1 0 4.243 4.243 3 3 0 0 0-4.243-4.243m-1.414-1.414a5 5 0 1 0 7.071 7.071 5 5 0 0 0-7.071-7.071",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m51.961 50.547 4.243 4.243-1.414 1.414-4.243-4.243zM16.573 40a3 3 0 1 0-6 0 3 3 0 0 0 6 0m2 0a5 5 0 1 0-10 0 5 5 0 0 0 10 0",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M24.084 41h-6v-2h6zM63.427 40a3 3 0 1 0 6 0 3 3 0 0 0-6 0m-2 0a5 5 0 1 0 10 0 5 5 0 0 0-10 0",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M55.916 39h6v2h-6zM56.565 23.435a3 3 0 1 0 4.243-4.243 3 3 0 0 0-4.243 4.243m-1.414 1.414a5 5 0 1 0 7.071-7.07 5 5 0 0 0-7.071 7.07",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m50.547 28.039 4.243-4.243 1.414 1.414-4.243 4.243zM23.435 56.565a3 3 0 1 0-4.243 4.243 3 3 0 0 0 4.243-4.243m1.414-1.414a5 5 0 1 0-7.071 7.07 5 5 0 0 0 7.071-7.07",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m29.453 51.961-4.243 4.243-1.414-1.414 4.243-4.243z",
    clipRule: "evenodd"
  })));
};
export default SvgValueGroup;